/**
 * Optional config context: fetches GET /api/v1/config and exposes tenancy for UI
 * (e.g. show "Contact support" vs "Local admin"). Not required for flags.
 */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchConfig } from '../../api/configApi';

const ConfigContext = createContext(null);

const DEFAULT_CONFIG = { tenancy: 'self_hosted' };

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    let cancelled = false;
    fetchConfig().then((data) => {
      if (!cancelled) setConfig(data);
    });
    return () => { cancelled = true; };
  }, []);

  const value = useMemo(() => config, [config]);

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  return ctx ?? DEFAULT_CONFIG;
}
